import React from 'react';

export const PaymentFlowTrackingContext = React.createContext({
  paymentFlowId: '',
});
